import img_open from "assets/img/service_google_sheets.svg";

import { Link } from "@mui/material";
import { MenuItemButton } from "components/menu/MenuItemButton";

export const MenuItemButtonGoToSpreadsheet = ({
  spreadsheetLink,
  handleClose,
}: {
  spreadsheetLink: string;
  handleClose: () => void;
}) => {
  return (
    <Link href={spreadsheetLink} target="_blank" color={"inherit"}>
      <MenuItemButton
        onClick={handleClose}
        iconSrc={img_open}
        title="Просмотр"
      />
    </Link>
  );
};
